<template>
  <div class="envelope-mail d-flex flex-column">
    <img class="bazili-handle d-flex align-self-end" src="@/assets/Bazili_Handle.png">
    <div class="envelope-letter-text position-absolutte d-flex flex-column">
      <h4 class="text-success m-0 pt-3 pb-2">
        {{ $t('activedSuccessfully.Congrats') }}
      </h4>
      <strong
        class="text-success m-0"
      >
        {{ $t('activedSuccessfully.yourEmailActivatedSuccssfully') }}
      </strong>
      <p class="m-0 text-dark">
        {{ $t('activedSuccessfully.mainDescription', {products: this.globalResources.productTranslation.Plural}) }}
      </p>
      <p class="m-0 text-dark">
        {{ $t('activedSuccessfully.renewSubscription') }}
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ActivatedSuccessfullyLetter'
}
</script>
